// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dubwool: PokeData = {
  "id": 832,
  "name": "dubwool",
  "height": 13,
  "weight": 430,
  "base_experience": 172,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "double-kick",
    "headbutt",
    "tackle",
    "take-down",
    "double-edge",
    "growl",
    "defense-curl",
    "reversal",
    "copycat",
    "guard-swap",
    "last-resort",
    "guard-split",
    "cotton-guard"
  ],
  "moves": [
    "double-kick",
    "headbutt",
    "tackle",
    "growl",
    "purification",
    "splash",
    "supersonic",
    "scratch",
    "tri-attack",
    "body-slam",
    "protect",
    "leer",
    "quick-attack"
  ],
  "evolution_chain": {
    "id": 438,
    "item": null,
    "species": [
      {
        "name": "wooloo",
        "order": 831,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dubwool",
        "order": 832,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 831,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 140,
    "ability_power": 127
  },
  "stat_changes": [],
  "catch_rate": 127,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
